import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../stores/initialStore';
import { InitialStates } from '../../@types/initialStates';

const initialState: InitialStates = {
  isLoading: true,
  error: false,
  ContenuList: [],
  ContenuDetailList: [],
  launchUrl: '',
  showPrevious: false,
  formations: [],
  ConversationList: [],
  currentConversation: 0,
  conversationDetail: [],
  showLateralBar: true,
  isWriting: false,
  showSliderPanel: false,
  showSearcheMessage:false,
  menuOpen:true
};

const slice = createSlice({
  name: 'projet',
  initialState,
  reducers: {
    startstopLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setMenuOpen(state, action: PayloadAction<boolean>) {
      state.menuOpen = action.payload;
    },
    toggleSearcheMessage(state, action: PayloadAction<boolean>) {
      state.showSearcheMessage = action.payload;
    },
    
  },
});

export default slice.reducer;

export const {
  startstopLoading,  
  setMenuOpen
} = slice.actions;

export const toggleLoading = (isLoading: boolean) => (dispatch: AppDispatch) => {
  try {
    dispatch(startstopLoading(isLoading));
  } catch (err) {   
  }
};

export const SetMenuOpen = (value: boolean) => (dispatch: AppDispatch) => {
  try {
    dispatch(setMenuOpen(value));
  } catch (err) {   
  }
};


